import logo from "assets/images/sportswear-erp.png";
function Footer() {
  return (
    <footer className="bg-dark py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <img
              src={logo}
              alt="OrderRun Logo"
              className="logo-dark"
              height="120"
            />
            <p className="text-muted mt-4">
              OrderRun is a comprehensive solution for sportswear
              manufacturers.
              <br /> Streamline operations from lead to delivery.
              <br /> Built for efficiency, designed for growth.
            </p>

            <ul className="social-list list-inline mt-3">
              <li className="list-inline-item text-center">
                <a
                  href="#"
                  className="social-list-item border-primary text-primary"
                >
                  <i className="mdi mdi-facebook"></i>
                </a>
              </li>
              <li className="list-inline-item text-center">
                <a
                  href="#"
                  className="social-list-item border-danger text-danger"
                >
                  <i className="mdi mdi-google"></i>
                </a>
              </li>
              <li className="list-inline-item text-center">
                <a href="#" className="social-list-item border-info text-info">
                  <i className="mdi mdi-twitter"></i>
                </a>
              </li>
              <li className="list-inline-item text-center">
                <a
                  href="#"
                  className="social-list-item border-secondary text-secondary"
                >
                  <i className="mdi mdi-github"></i>
                </a>
              </li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-4 mt-3 mt-lg-0">
            <h5 className="text-light">Company</h5>

            <ul className="list-unstyled ps-0 mb-0 mt-3">
              <li className="mt-2">
                <a href="#" className="text-muted">
                  About Us
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Documentation
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Blog
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Affiliate Program
                </a>
              </li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-4 mt-3 mt-lg-0">
            <h5 className="text-light">Modules</h5>

            <ul className="list-unstyled ps-0 mb-0 mt-3">
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Sales & CRM
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Manufacturing
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Inventory
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Marketing
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Analytics
                </a>
              </li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-4 mt-3 mt-lg-0">
            <h5 className="text-light">Discover</h5>

            <ul className="list-unstyled ps-0 mb-0 mt-3">
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Help Center
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Our Products
                </a>
              </li>
              <li className="mt-2">
                <a href="#" className="text-muted">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="mt-5">
              <p className="text-muted mt-4 text-center mb-0">
                © {new Date().getFullYear()} OrderRun. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
